import { render, staticRenderFns } from "./TheUpsertCustomerAddress.vue?vue&type=template&id=c1952246"
import script from "./TheUpsertCustomerAddress.vue?vue&type=script&lang=ts"
export * from "./TheUpsertCustomerAddress.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports